module.exports = __webpack_public_path__ + "static/media/Image.87385568.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reusable/images/Image.svg
// module id = 959
// module chunks = 0